import FieldDecoder from './FieldDecoder.js';

class FieldDecoderSimulationTime extends FieldDecoder {
    /**
     * @constructor
     */
    constructor() {
        super();
    }

    /**
     * @protected
     * @param {BitBuffer} bitBuffer
     * @returns {number}
     */
    _decode(bitBuffer) {
        return bitBuffer.readUVarInt32();
    }
}

export default FieldDecoderSimulationTime;
